import React from 'react';
import { Lock, Sparkles } from 'lucide-react';

/**
 * PremiumLockPage Component
 * Halaman yang menampilkan pesan untuk fitur premium yang terkunci
 */
const PremiumLockPage = ({ onUpgrade }) => {
    const handleUpgrade = () => {
        if (onUpgrade) {
            onUpgrade();
        } else {
            alert('Fitur upgrade akan segera hadir! Hubungi admin untuk info lebih lanjut.');
        }
    };

    return (
        <div className="p-8 text-center flex flex-col items-center justify-center h-full bg-gray-50">
            <div className="bg-white p-10 rounded-2xl shadow-lg">
                <Lock size={48} className="text-yellow-500 mb-4 mx-auto" />
                <h2 className="text-2xl font-bold mb-2 text-gray-800">Fitur Ini Memerlukan Lisensi</h2>
                <p className="text-gray-600 mb-6 max-w-md">
                    Silakan aktifkan lisensi atau berlangganan untuk mengakses fitur ini. Dapatkan akses penuh ke fitur AI dan tingkatkan produktivitas mengajar Anda.
                </p>
                <button
                    onClick={handleUpgrade}
                    className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-6 rounded-lg flex items-center mx-auto transition-transform transform hover:scale-105"
                >
                    <Sparkles size={20} className="mr-2" />
                    Lihat Paket Langganan
                </button>
            </div>
        </div>
    );
};

export default PremiumLockPage;

